import { formatDays } from "@/lib/format";
import type { PtoBalanceOtherLeave } from "@/lib/pto-balance";

interface OtherLeaveSummaryProps {
  otherLeave: PtoBalanceOtherLeave;
}

// Informational only — sick/other entries never draw down either balance
// (see src/lib/pto-balance.ts), so this is deliberately not a Card with a
// progress bar, just a small record-keeping note under the balance cards.
export function OtherLeaveSummary({ otherLeave }: OtherLeaveSummaryProps) {
  return (
    <p className="text-xs text-muted-foreground px-1">
      Also recorded this year: {formatDays(otherLeave.sick.usedDays)} sick,{" "}
      {formatDays(otherLeave.other.usedDays)} other — not counted against your balance.
    </p>
  );
}
